export const BooksChatGeneric = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M1.33333 13.3333H13.3333V16H1.33333C0.596667 16 0 15.4033 0 14.6667C0 13.93 0.596667 13.3333 1.33333 13.3333ZM13.3333 1.33333V12H1.33333C0.841333 11.9993 0.366 12.1807 0 12.51V2C0 0.895333 0.895333 0 2 0H12C12.7367 0 13.3333 0.596667 13.3333 1.33333Z"
      fill="currentColor"
    />
  </svg>
);
